import dayjs from 'dayjs'
import React from 'react'
import style from './style.module.scss'

type heroSlideInfosProps = {
    date: string
    readingTime?: number
    access?: string
    price?: number
}

export const HeroSlideInfos: React.FC<heroSlideInfosProps> = ({
    date,
    readingTime,
    access,
    price,
}) => {
    return (
        <div className={style.infos}>
            <p>{dayjs(date).format('D MMM YYYY')}</p>

            {readingTime && (
                <p className={style.readingTime}>
                    <i className="fi fi-rs-stopwatch" />
                    {readingTime + ' '}MIN.
                </p>
            )}

            {access && (
                <p className={style.price}>
                    {access === 'free' ? (
                        <>ACCÈS LIBRE</>
                    ) : (
                        price && (
                            <>
                                <i className="fi fi-rs-ticket" />À PARTIR DE {price}€
                            </>
                        )
                    )}
                </p>
            )}
        </div>
    )
}
